function initCustomProductSliders() {
    const sliderSections = document.querySelectorAll(".custom-product-slider-section");
    sliderSections.forEach((section, index) => {
        if (section.classList.contains("swiper-initialized")) return;
        const interval = setInterval(() => {
            const swiperContainer = section.querySelector(".custom-product-slider");
            const nextBtn = section.querySelector(".swiper-button-next");
            const prevBtn = section.querySelector(".swiper-button-prev");
            const rawSlide = parseInt(section.dataset.slide, 10);
            const slideCount = !isNaN(rawSlide) && rawSlide > 0 ? rawSlide : 3;
            if (swiperContainer && nextBtn && prevBtn) {
                new Swiper(swiperContainer, {
                    slidesPerView: 1.41,
                    spaceBetween: 4,
                    speed: 800,
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                    breakpoints: {
                        568: {
                            slidesPerView: 2.4,
                        },
                        1024: {
                            slidesPerView: slideCount,
                        },
                    },
                });
                section.classList.add("swiper-initialized");
                clearInterval(interval)
            }
        }, 300)
    })
}
document.addEventListener("DOMContentLoaded", function() {
    initCustomProductSliders()
})